import { useEffect, useState } from 'react';

/**
 * Estado del detalle de avance y notificación al modal padre.
 * @param onDetalleAvanceChange callback cuando cambia abierto/cerrado
 * @returns estado y setters del detalle
 */
const useDetalleAvanceToggle = (onDetalleAvanceChange?: (abierto: boolean) => void) => {
  const [detalleAbierto, setDetalleAbierto] = useState(false);

  useEffect(() => {
    if (onDetalleAvanceChange) {
      onDetalleAvanceChange(detalleAbierto);
    }
    return () => {
      if (onDetalleAvanceChange) {
        onDetalleAvanceChange(false);
      }
    };
  }, [detalleAbierto, onDetalleAvanceChange]);

  return { detalleAbierto, setDetalleAbierto };
};

export default useDetalleAvanceToggle;
